import styled from "styled-components";
import { Checkbox } from "@evergis/ui";

export const CardCheckbox = styled(Checkbox)`
  padding-left: 0.5rem;
`;
